import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { AuthCard } from '../../components/AuthLayout';
import { useApi } from '../../auth/AuthProvider';
import { useTranslation } from '../../i18n/I18nProvider';
import { SkeletonText } from '../../ui';

export function VerifyEmail() {
  const { t } = useTranslation();
  const api = useApi();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [state, setState] = useState<'pending' | 'done' | 'failed'>(token ? 'pending' : 'failed');
  const started = useRef(false);

  useEffect(() => {
    if (!token || started.current) return;
    started.current = true;
    void api.auth
      .verifyEmail({ token })
      .then(() => setState('done'))
      .catch(() => setState('failed'));
  }, [api, token]);

  return (
    <AuthCard
      title={t('auth.verifyTitle')}
      footer={
        <Link to="/prijava" className="text-accent-dark underline">
          {t('auth.backToLogin')}
        </Link>
      }
    >
      {state === 'pending' && (
        <div aria-busy="true">
          <p className="mb-3 text-[14.5px] text-ink-muted">{t('auth.verifyPending')}</p>
          <SkeletonText lines={2} />
        </div>
      )}
      {state === 'done' && (
        <p role="status" className="text-[14.5px] text-ink">
          {t('auth.verifyDone')}
        </p>
      )}
      {state === 'failed' && (
        <p role="alert" className="text-[14.5px] text-danger">
          {t('auth.verifyFailed')}
        </p>
      )}
    </AuthCard>
  );
}
